import React from "react";
import Page from "../Components/Page";
import ControlPanel from "../features/controls/ControlForm";
import { useParams } from "react-router-dom";
import useFetchData from "../hooks/useFetchData";
import { IControl } from "../features/controls/types";

export default function ControlPage() {
  const params = useParams();
  const { data: control, isLoading } = useFetchData<IControl>(
    `/controls/${params.controlid}`,
  );
  return (
    <Page title={control?.name} isLoading={isLoading}>
      {control && <ControlPanel control={control} />}
    </Page>
  );
}
